import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'articleshowbriefs' */ './ArticleshowBriefsMain'),
  loading: () => null,
});

export default class WithArticleshowBriefs extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ load: true });
    }, 1000);
  }
  render() {
    if (!this.state.load) {
      return null;
    }
    return <LoadableComponent {...this.props} />;
  }
}
